/* eslint-disable no-console */
'use strict'

const state = {
  lang: null
}

const mutations = {
  SET_LANG: (state, lang) => {
    if (lang === null) {
      lang = 'fr'
    }
    state.lang = lang
    localStorage.setItem(process.env.VUE_APP_I18N_LOCALE_NAME, lang)
  },
  REMOVE_LANG: (state) => {
    state.lang = null
    localStorage.removeItem(process.env.VUE_APP_I18N_LOCALE_NAME)
  }
}

const getters = {
  lang: state => { return state == null ? null : state.lang }
}

const actions = {
  // eslint-disable-next-line no-unused-vars
  actionA ({ commit }) {
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, 1000)
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
